export const TRIAL_REMINDER_MS = 15000;
export const TRIAL_PRODUCTS_EVENT = "webprofit:trial-products-updated";
export const TRIAL_LANDING_EVENT = "webprofit:trial-landing-updated";
export const TRIAL_SOUND_STORAGE_KEY = "webprofit_trial_coach_sound";

function clean(value) {
  return String(value ?? "").trim();
}

function hasAnyValue(values = []) {
  return values.some((value) => clean(value));
}

export function isTrialProject(project, now = new Date()) {
  if (String(project?.billing?.status || "").trim().toLowerCase() !== "trial") return false;
  const rawEnd = project?.billing?.trialEndsAt;
  if (!rawEnd) return true;
  const trialEndsAt = new Date(rawEnd);
  return Number.isNaN(trialEndsAt.getTime()) || now <= trialEndsAt;
}

export function getLandingTrialProgress(settings = {}) {
  const business = settings?.business || {};
  const hero = settings?.hero || {};
  const theme = settings?.theme || {};
  const slides = Array.isArray(hero?.slides) ? hero.slides : [];

  const businessDone = Boolean(
    clean(business.name) &&
      hasAnyValue([
        business.whatsapp,
        business.phone,
        business.email,
        business.address,
      ]),
  );

  const heroDone = Boolean(
    clean(hero.title) &&
      hasAnyValue([
        hero.imageUrl,
        theme.logoUrl,
        theme.compactLogoUrl,
        ...slides.map((slide) => slide?.url),
      ]),
  );

  const published = clean(settings?.publicStatus).toLowerCase() === "published";
  const completedCount = [businessDone, heroDone, published].filter(Boolean).length;

  return {
    businessDone,
    heroDone,
    published,
    completedCount,
    totalCount: 3,
    percent: Math.round((completedCount / 3) * 100),
  };
}

export function buildTrialMissions({ settings = {}, productCount = 0, modules = {} } = {}) {
  const landing = getLandingTrialProgress(settings);
  const missions = [];

  if (modules?.landing !== false) {
    missions.push({
      id: "business",
      label: "Completar datos del negocio",
      description: "Nombre, WhatsApp, teléfono o dirección.",
      done: landing.businessDone,
      routeKey: "datos",
      section: "landing",
    });
    missions.push({
      id: "hero",
      label: "Personalizar la portada",
      description: "Título principal y una imagen o logo real.",
      done: landing.heroDone,
      routeKey: "portada",
      section: "landing",
    });
  }

  if (modules?.products !== false) {
    missions.push({
      id: "product",
      label: "Cargar un producto o servicio",
      description: "Usá productos y servicios sin límites durante la prueba.",
      done: Number(productCount || 0) > 0,
      routeKey: "producto",
      section: "products",
    });
  }

  if (modules?.landing !== false) {
    missions.push({
      id: "publish",
      label: "Publicar la landing",
      description: "Dejar la web visible para compartirla.",
      done: landing.published,
      routeKey: "publicar",
      section: "landing",
    });
  }

  const completedCount = missions.filter((mission) => mission.done).length;

  return {
    missions,
    completedCount,
    totalCount: missions.length,
    percent: missions.length ? Math.round((completedCount / missions.length) * 100) : 100,
    nextMission: missions.find((mission) => !mission.done) || null,
    complete: missions.length > 0 && completedCount === missions.length,
    landing,
  };
}

export function trialWelcomeStorageKey(projectKey) {
  return `webprofit_trial_landing_welcome_${projectKey}`;
}
